<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.text-center(v-if="!entity")
      v-col.py-0
        h2.primary--text No entity selected
        small.white--text Select an entity from the sidebar list.
    v-row(v-else)
      v-col.py-0
        v-card.px-10.py-5.my-5
          v-overlay(absolute, v-if="loading")
          g-data-table(
            dense,
            :headers="$fieldsToHeaders(entity, $fields(entity, 'primitive'))",
            :items="pagination.data",
            :options.sync="options",
            :server-items-length="pagination.total",
            v-bind="{ loading }",
          )
            template(v-slot:no-data)
              h2 {{ $pascalToHuman(entityName) }} doesn't have items
              small Create an item for this entity or change search criteria.
            template(v-slot:top)
              app-entity-search(
                :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
                @pagination="pagination = $event",
                :loads="loads",
                :entity="entity",
                :emit="true",
                :rowsPerPage="options.itemsPerPage || null"
              )
            template(v-slot:item.tags="{ item }")
              v-layout.my-1(v-for="tag in item.tags")
                v-chip(color="primary") {{ tag.user.tagListName }}
            template(v-slot:item.action="{ item }")
              a(
                v-if="ShowEntityEdit(entityName) || ShowEntityView(entityName)",
                style="text-decoration: none",
                @click="$savePaginationAndRoute(entityName, pagination, options, getRouterLinkForComment(item))",
              )
                v-icon(small) mdi-eye
    v-row
      v-snackbar(v-model="snackbar")
        | {{ message }}
        v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import keys from 'lodash/keys'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete
  },
  name: 'comment-index',
  mixins: [
    EntiyLoadsMixin,
    IndexFilterMixin,
  ],
  data: () => ({
    message: '',
    commentEntities: ["Order", "Shipment"],
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {
      where: [],
    },
    options: {}
  }),

  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },
  computed: {
    entityName () {
      return 'Comment'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    }
  },
  methods: {
    getRouterLinkForComment(item){
      return `/${this.$scope()}/${item.commentEntity}/${item.commentEntityUid}/edit?fromComments=true`;
    },
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      }
    },

    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          try {
            const envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint');
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            pagination.params = _.merge(pagination.params, envParams);
            this.pagination = (await axios.get(this.$fetchLoad(envEndpoint || this.entityName, !envEndpoint, ...this.loads.concat(this.commentEntities)), pagination)).data
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    /* TODO: docs */
    async remove (entity) {
      this.loading = true
      entity.entityState = ENV.ENTITY.STATE.DELETED
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.load(this.options)
    },

    getEditAttribute(item) {
      return _.get(item, _.get(ENV.ENTITIES, this.entityName  + '.index.editAttribute', 'orderId'));
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },
    getSavedPagination() {
      const { pagination, options } = this.$getSavedPagination(this.entityName);
      if(pagination && options) {
        this.pagination = pagination;
        this.options = options;
        this.load(this.options);
      }
    },
  },
  created() {
    this.getSavedPagination();
  },
}
</script>
